const invoiceActionTypes = {
    START_GET_INVOICES_LIST: 'START_GET_INVOICES_LIST',
    GET_INVOICES_LIST_SUCCESS: 'GET_INVOICES_LIST_SUCCESS',
    GET_INVOICES_LIST_FAILURE: 'GET_INVOICES_LIST_FAILURE',

    START_GET_INVOICES_SUMMARY_LIST: 'START_GET_INVOICES_SUMMARY_LIST',
    GET_INVOICES_LIST_SUMMARY_SUCCESS: 'GET_INVOICES_LIST_SUMMARY_SUCCESS',
    GET_INVOICES_LIST_SUMMARY_FAILURE: 'GET_INVOICES_LIST_SUMMARY_FAILURE',
   
    START_EXPORT_CAHRGING_SUMMARY_FILE: 'START_EXPORT_CAHRGING_SUMMARY_FILE',
    GET_EXPORT_CAHRGING_SUMMARY_FILE_SUCCESS: 'GET_EXPORT_CAHRGING_SUMMARY_FILE_SUCCESS',
    GET_EXPORT_CAHRGING_SUMMARY_FILE_FAILURE: 'GET_EXPORT_CAHRGING_SUMMARY_FILE_FAILURE',
}


export default invoiceActionTypes;